export default () => {
  const photoGalleryContainers = document.querySelectorAll('.js-photo-gallery');

  if (!photoGalleryContainers) {
    return;
  }

  photoGalleryContainers.forEach(photoGalleryContainer => {
    const galleryId = photoGalleryContainer.dataset.galleryId;
    if (!galleryId) return;

    const photoGalleryModalContainer = document.querySelector(
      `.js-photo-gallery-modal[data-gallery-id="${galleryId}"]`
    );
    if (!photoGalleryModalContainer) return;

    import('./Photo_Gallery' /* webpackChunkName: "photogallery" */).then(
      ({ initializeForElement }) => {
        initializeForElement(
          galleryId,
          photoGalleryContainer,
          photoGalleryModalContainer
        );
      }
    );

  });
};
